<div #surveyVizPanel></div>